import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPinnedPostsKey, getPostKey, getPostsKey, } from '../../utils/keys';
import { getCachedPost } from '../cache/useCachedPost';
import { getPostsQueryById } from './filters';
export const useDeletePost = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const pinnedPostKey = getPinnedPostsKey();
    return useMutation((input) => client.posts.delete(input, fields), {
        onMutate: variables => {
            queryClient.cancelQueries(pinnedPostKey);
            queryClient.setQueriesData(pinnedPostKey, old => old.filter(post => (variables === null || variables === void 0 ? void 0 : variables.id) && (post === null || post === void 0 ? void 0 : post.id) !== (variables === null || variables === void 0 ? void 0 : variables.id)));
        },
        onSettled: (data, error, input) => {
            const postKey = getPostKey({ variables: { id: input === null || input === void 0 ? void 0 : input.id } });
            queryClient.removeQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            const feedKey = getFeedKey();
            queryClient.invalidateQueries(feedKey);
            queryClient.invalidateQueries(pinnedPostKey);
            const cachedPost = getCachedPost(input.id, queryClient);
            // we want to "refetch" only replies query if any
            // (invalidate does not work for disabled queries)
            // (replies withing a reply is a disabled query)
            const parentPostId = cachedPost.repliedToId;
            if (parentPostId) {
                queryClient.refetchQueries(getPostsQueryById(parentPostId));
            }
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useDeletePost.js.map